import { render, staticRenderFns } from "./LayoutContentRendererLeftDetached.vue?vue&type=template&id=ba45de68&"
import script from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba45de68')) {
      api.createRecord('ba45de68', component.options)
    } else {
      api.reload('ba45de68', component.options)
    }
    module.hot.accept("./LayoutContentRendererLeftDetached.vue?vue&type=template&id=ba45de68&", function () {
      api.rerender('ba45de68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue"
export default component.exports